import { packeryEvents } from "vue-packery-plugin";
import { EventBus } from "../../../eventbus";
import LazyList from "lazy-load-list/vue";

export default {
  props: {
    isLoading: Boolean,
    checkboxId: String,
    hasFileOptions: Boolean,
    files: {
      type: Array,
      default: () => [],
    },
    layout: String,
  },
  components: { LazyList },
  data() {
    return {
      id: this.$options.name,
      placeHolderCount: 16,
      timer: false,
    };
  },
  created() {
    this.displayPlaceHolders();

    EventBus.$on(`${this.id}-layout`, this.updateLayout);
  },
  methods: {
    updateLayout() {
      if (this.$refs.packery) {
        packeryEvents.$emit("layout", this.$refs.packery);
      }
    },
    displayPlaceHolders() {
      this.timer = false;

      //wait before showing the placeholders
      setTimeout(() => {
        this.timer = true;
      }, 1500);
    },
  },
  computed: {
    showPlaceHolders() {
      return (this.files.length === 0 && this.timer) || !this.isLoading;
    },
  },
  watch: {
    files() {
      this.displayPlaceHolders();
    },
    isLoading() {},
    layout() {
      this.updateLayout();
    },
  },
};
